import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseBuildingBlockComponent } from '../building-blocks/components/base-building-block.component';
import { LastItemBgClass } from '../shell/shell.service';

@Component({
  selector: 'ss-www-info-bar',
  imports: [],
  templateUrl: './info-bar.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBarComponent extends BaseBuildingBlockComponent {
  override getBgClass(): LastItemBgClass {
    return 'bg-black';
  }
}
